var $ = require("jquery");

$(document).ready(function () {
    $("#playButton").click(function () {
        $('#theVideo').get(0).play();
        $('#playButton').remove();
        $('#theVideo').attr('controls', true);
    });
});